import {
  BOUND_OF_SEARCH_AUTOCOMPLETE,
  COUNT_OF_QUERY,
  StateOfAutocomplete,
} from '@/constants/components/autocomplete'

import { useCityStore } from '@/store/city/city'

import { Success } from '@/api/results'

export const useAutocompleteAddress = () => {
  const cityStore = useCityStore()

  const cityInfo = computed(() => {
    return {
      countryName: cityStore.cityInfo.country?.name || '',
      cityName: cityStore.cityName || '',
      codeRegion: String(cityStore.cityState?.code) || '',
      nameRegion: cityStore.cityState?.name || '',
    }
  })

  // Новый fetch для автокомплита
  const fetchFromNewSuggestions = async (request: string) => {
    const { $apiService } = useNuxtApp()

    const result = await $apiService.geocode.getSuggestedSearchesOfAddress(
      request,
      BOUND_OF_SEARCH_AUTOCOMPLETE.HOUSE,
      cityInfo.value.countryName,
      cityInfo.value.codeRegion,
      cityInfo.value.cityName,
    )

    if (!(result instanceof Success)) {
      searchSuggestionsError.value = result.message

      return
    }

    // Если нет подсказок
    if (!result.data.length) {
      searchSuggestionsError.value = StateOfAutocomplete.NOT_FOUND

      return
    }

    searchSuggestionsError.value = ''

    return result.data
  }

  const searchSuggestionsError = ref('')
  const searchSuggestionsLoading = ref(false)

  // Поиск совпадений по адресу
  const searchSuggestions = async (request: string | null) => {
    if (!isRequestValid(request) || !request) {
      searchSuggestionsError.value = StateOfAutocomplete.EMPTY

      return []
    }

    searchSuggestionsLoading.value = true

    // В зависимости от тагла определяем вызов
    const result = await fetchFromNewSuggestions(request)

    searchSuggestionsLoading.value = false

    return result || []
  }

  const isRequestValid = (request: string | null) => {
    return request && request.length >= COUNT_OF_QUERY
  }

  return {
    searchSuggestions,
    isRequestValid,
    searchSuggestionsError,
    searchSuggestionsLoading,
  }
}
